import { User } from './../../user-details-forum/user-details-forum.component';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs'
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BadgeServiceService {

  // List of users in basket
  public users: User[] = [];
  public editUser: boolean = false;
  //testing
  //public baseUrl: string = "http://localhost:5000";

  //Live
  public baseUrl: string = "https://apps.wea.org.uk/WorldPayServicesAPIFree";

  usersObservable = new Subject<User[]>();

  editUserObservable = new Subject<User>();

  public selectedUser: User = {
    employerName: '',
    paName: '',
    county: '',
    address: '',
    email: '',
    image: '',
    id: 0
  }

  constructor(private httpService: HttpClient) { }


  sendPaymentRequest(obj: object): any {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': '*/*',
      'Access-Control-Allow-Origin': "*"
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
      mode: 'no-cors'
    };
    return this.httpService.post(`${this.baseUrl}/api/payment/request`, obj, requestOptions);
  }

  insertOrders(orders: any[]) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': '*/*',
      'Access-Control-Allow-Origin': "*"
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
      mode: 'no-cors'
    };
    var splitPathName = document.location.pathname.split('/');
    return this.httpService.post(`${this.baseUrl}/api/payment/insert?frontEndUrl=${document.location.protocol}//${document.location.host}/${splitPathName[1]}`, orders, requestOptions);
  }

}